export class WorkflowSubmissionStrings {
  /** This will be used as a direct child of _/workbenches/:projectId/workflows_ */
  static BASE_ROUTE = "submissions";
  /** This will be used as a direct child of _/workbenches/:projectId/workflows/{@link WorkflowSubmissionStrings.BASE_ROUTE}_ */
  static NEW_SUBMISSION_ROUTE = "new-submission";
  /** This will be used as a direct child of _/workbenches/:projectId/workflows/{@link WorkflowSubmissionStrings.BASE_ROUTE}_ */
  static DETAIL_ROUTE = ":pipelineId/:tab?";

  static SIDE_NAV_TITLE = "Submissions";

  static SUBMISSIONS_LIST = {
    TITLE: "Submissions",
    NEW_SUBMISSION_BUTTON: "New Submission",
    EMPTY_LIST_MESSAGE: "You don't have any submissions.",
    EMPTY_FILTERED_LIST_MESSAGE: "No submissions found.",
  } as const;

  static NEW_SUBMISSION = {
    TITLE: "New Workflow",
    SUBTITLE:
      "Define all core settings for your new submission, including the workflow language, execution engine, and advanced configuration.",
    BACK_BUTTON: "Back to Workflows",
    BACK_BUTTON_ACTIVITY: "Back to Activity",
    BACK_BUTTON_SAVED: "Back to Saved",

    SUMMARY: {
      PIPELINE_TO_LAUNCH: "Pipeline to launch",
    },

    ERRORS: {
      GIT_URL_REQUIRED: "Workflow URL is required when using Git source",
      ERROR_LAUNCHING_SUBMISSION: "Error launching new submission!",
      ERROR_FETCHING_PARAMETERS: (errorMessage: string) =>
        `Error fetching workflow parameters: ${errorMessage}`,
      OUTPUT_LOCATION_UNAVAILABLE:
        "Couldn't determine a default output location for this workbench folder. Please try again in a moment.",
    },
  } as const;

  static SUBMISSION_DETAILS = {
    HEADERS: {
      ID: "Submission ID",
      RUN_ID: "Run ID",
      STARTED: "Started",
      ELAPSED: "Elapsed",
      ESTIMATED_COST: "Est. Cost",
      STATUS: "Status",
    },
    TABS: {
      TASKS: "Tasks",
      LOGS: "Logs",
      CONFIGURATION: "Configuration",
    },
  } as const;
}
